import React from 'react';
import CardText from "../../../Actu/CardText";
import CardImage from "../../../Actu/CardImage";

const BlogList = ({nbPages,data,page,onPageChange,context}) => {

    const {org}=context

    return(
        <section className="wpo-blog-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-8">
                        <div className="wpo-blog-content">

                            {data.map(item=>{

                                const link=org.BASE_WEB_URL+"/actualite/"+item.id
                                switch (item.type)
                                {
                                    case "TEXT":
                                        return <CardText context={context} link={link} item={item}/>
                                    case "IMAGE":
                                        return <CardImage context={context} link={link} item={item}/>
                                    case "LINK":
                                        return <CardText context={context} link={item.link} item={item}/>
                                }
                            })}


                            <div className="pagination-wrapper pagination-wrapper-left">
                                <ul className="pg-pagination">
                                    {page>1 &&(
                                        <li>
                                            <a onClick={()=>onPageChange(page-1)} href="#" aria-label="Previous">
                                                <i className="fi ti-angle-left"></i>
                                            </a>
                                        </li>
                                    )}


                                    {[...Array(nbPages).keys()].map(_p=>{
                                        const p=_p+1
                                        const className=p===page?"active":""
                                        const active=p===page
                                        return(
                                            <li className={className}><a onChange={active?null:()=>onPageChange(p)} href="#">{p}</a></li>
                                        )
                                    })}

                                    {page<nbPages &&(
                                        <li>
                                            <a onClick={()=>onPageChange(page+1)} href="#" aria-label="Next">
                                                <i className="fi ti-angle-right"></i>
                                            </a>
                                        </li>
                                    )}

                                </ul>
                            </div>

                        </div>
                    </div>
                    {/*<BlogSidebar/>*/}
                </div>
            </div>
        </section>
     )

}

export default BlogList;
